import { CRYPTO } from 'src/config-global';
import CryptoJS from 'crypto-js';

export function getFileExtension(file) {
    if (file && file.name) {
        const fileNameParts = file.name.split(".");
        if (fileNameParts.length > 1) {
            return `.${fileNameParts[fileNameParts.length - 1]}`;
        }
    }
    return "";
}

export function validatePhoneNumber(value) {
    // const phoneNumberRegex = /^\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/;
    const phoneNumberRegex = /^\+[1-9]\d{1,14}$/;
    return phoneNumberRegex.test(value);
}

const KNOWN_DOMAINS = [
    "gmail.com", "yahoo.com", "hotmail.com", "outlook.com",
    "icloud.com", "live.com", "aol.com", "protonmail.com"
];

function levenshteinDistance(a, b) {
    const matrix = Array.from({ length: a.length + 1 }, () => []);

    for (let i = 0; i <= a.length; i++) matrix[i][0] = i;
    for (let j = 0; j <= b.length; j++) matrix[0][j] = j;

    for (let i = 1; i <= a.length; i++) {
        for (let j = 1; j <= b.length; j++) {
            const cost = a[i - 1] === b[j - 1] ? 0 : 1;
            matrix[i][j] = Math.min(
                matrix[i - 1][j] + 1,      
                matrix[i][j - 1] + 1,      
                matrix[i - 1][j - 1] + cost 
            );
        }
    }

    return matrix[a.length][b.length];
}

export function validateEmail(value) {
    if (!value) return { isValid: false, suggestion: null };
    
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(value)) {
        return { isValid: false, suggestion: null };
    }

    const domain = value.split('@')[1]?.toLowerCase();
    
    if (KNOWN_DOMAINS.includes(domain)) {
        return { isValid: true, suggestion: null };
    }

    let closestDistance = Infinity;
    let closestDomain = null;

    for (const known of KNOWN_DOMAINS) {
        const distance = levenshteinDistance(domain, known);
        if (distance < closestDistance) {
            closestDistance = distance;
            closestDomain = known;
        }
    }

    if (closestDistance > 0 && closestDistance <= 2) {
        return { isValid: false, suggestion: closestDomain }; 
    }

    return { isValid: true, suggestion: null };
}

export function encrypt(data){
    const cipherText = CryptoJS.AES.encrypt(data, CRYPTO);
    console.log(cipherText);

    return cipherText;
}

export function decrypt(cipherText){
    const bytes = CryptoJS.AES.decrypt(cipherText, CRYPTO);
    var originalText = bytes.toString(CryptoJS.enc.Utf8);
    
    console.log(originalText);

    return originalText;
}

export function checkIsDocumentPdf(type) {
    if (!type) return false;
    
    // Check for PDF MIME type or PDF string type
    if (type === "application/pdf" || type === "PDF") return true;
    
    // If it's a string, check if it ends with .pdf (ignoring case and query params)
    if (typeof type === 'string') {
        return /\.pdf(\?|$)/i.test(type);
    }
    
    return false;
}

export function readCSVFile(csvText, columnName){
    const lines = csvText.trim().split(/\r?\n/);  // split by line
    const headers = lines[0].split(",");          // get header row
    const colIndex = headers.indexOf(columnName);

    if (colIndex === -1) {
      return null;
    }

    const values = lines.slice(1).map(line => {
      const cols = line.split(",");

      return cols[colIndex]?.trim();
    });

    return values;
}

export function formatDate(inputDateString) {
    if(!inputDateString) return "";
    
    const inputDate = new Date(inputDateString);

    const year = inputDate.getFullYear();
    const month = String(inputDate.getMonth() + 1).padStart(2, "0");
    const day = String(inputDate.getDate()).padStart(2, "0");
    
    return `${year}-${month}-${day}`;
}

export function formatDateWithTime(inputDateString) {
    if(!inputDateString) return "";
    
    return new Date(inputDateString).toLocaleString();
}

export function getCountryCodeWithoutFlag(code) {
    const plusIndex = code.indexOf('+');
    return code.substring(plusIndex);
}

export function getCountryCodeList(countriesList) {
    const list = [];

    countriesList.map(({countryCallingCode, name}, index) => {
        list.push({id: index, label: `${name} (${countryCallingCode})`, value: countryCallingCode, code: countryCallingCode, name: name});
    });

    list.sort((a, b) => {
        // Compare labels using localeCompare for case-insensitive and language-sensitive sorting
        return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
    });

    return list;
}

export function showMobileNumberSecurely(num){
    let txt = "";

    for(let i = 0; i < num.length; i++){
        if(i < 3)
            txt += num[i];
        else if(i > num.length - 4)
            txt += num[i];
        else
            txt += "*";
    }

    return txt;
}

// Fixed version of the problematic function
export function getCountryCodeWithFlagFromCountryCodeAlone(code, list){
    let countryCode = '';
    
    // Simplified and more efficient approach
    const country = list.find(item => item.countryCallingCode === code);
    if (country) {
        countryCode = `${country.emoji} `;
    }
    
    return `${countryCode}${code}`;
}

export const getNameWithFirstLetterCapital = (word) => {
    if(!word) return "";

    const modifiedWord = word?.replaceAll("_", " ").toLowerCase();

    if(modifiedWord.length > 1){
        return modifiedWord[0].toUpperCase() + modifiedWord.substring(1);
    }

    return modifiedWord;
}

export const toCents = (amount) => {
    if (!amount) return 0;
    return Math.round(Number(amount) * 100);
};

export const fromCents = (cents) => {
    if (!cents) return 0;
    return Number(cents) * 0.01;
};

/**
 * Validates a Sri Lankan NIC number.
 * Accepts:
 *  - Old format: 9 digits + V or X (e.g. 123456789V)
 *  - New format: 12 digits only (e.g. 200012345678)
 * Rejects anything shorter/longer or with invalid characters.
 */
export function validateNIC(value) {
    if (!value) return false;

    const nic = value.trim().toUpperCase();

    const oldNicPattern = /^[0-9]{9}[VX]$/;   // 9 digits + V/X
    const newNicPattern = /^[0-9]{12}$/;      // 12 digits

    return oldNicPattern.test(nic) || newNicPattern.test(nic);
}

/**
 * Validates a passport number.
 * Accepts:
 *  - Sri Lankan passport: N + 7 digits (e.g. N1234567)
 *  - General international passport: 6-9 alphanumeric characters
 *    (covers most other countries for users living/travelling abroad)
 */
export function validatePassport(value) {
    if (!value) return false;

    const passport = value.trim().toUpperCase();

    const sriLankanPassportPattern = /^N[0-9]{7}$/;
    const internationalPassportPattern = /^[A-Z0-9]{6,9}$/;

    return sriLankanPassportPattern.test(passport) || internationalPassportPattern.test(passport);
}

/**
 * Combined validator: accepts either a valid NIC or a valid passport.
 * Useful when a single form field lets the user submit either document type.
 */
export function validateNICOrPassport(value) {
    return validateNIC(value) || validatePassport(value);
}

export function validateDocument(value) {
    if (!value) return { isValid: false, errorKey: 'nicRequired' };

    const cleanValue = value.replace(/[\s-]/g, '');

    // 1. Sri Lankan Passport (Starts with N, O, M, L, or D)
    if (/^[nNoOmMlLdD]/i.test(cleanValue)) {
        if (/^[nNoOmMlLdD][0-9]{7}$/i.test(cleanValue)) {
            return { isValid: true };
        }
        return { isValid: false, errorKey: 'invalidLkPassportRange' };
    }

    // 2. Sri Lankan Old NIC (Pure numbers followed by V or X)
    if (/^[0-9]+[vVxX]$/i.test(cleanValue)) {
        if (/^[1-9][0-9]{8}[vVxX]$/i.test(cleanValue)) {
            return { isValid: true };
        }
        return { isValid: false, errorKey: 'invalidOldLkNicRange' };
    }

    // 3. Sri Lankan New NIC (Starts with 19 or 20 and ONLY contains numbers)
    if (/^(19|20)[0-9]*$/.test(cleanValue)) {
        if (/^(19|20)[0-9]{10}$/.test(cleanValue)) {
            return { isValid: true };
        }
        return { isValid: false, errorKey: 'invalidNewLkNicRange' };
    }

    // 4. Broad Global Check (6 to 15 alphanumeric characters)
    if (/^[a-zA-Z0-9]{6,15}$/.test(cleanValue)) {
        return { isValid: true };
    }

    return { isValid: false, errorKey: 'invalidGlobalDocumentRange' };
}

export const toUTCDateString = (dateObj) => {
    if (!dateObj) return null;
    const d = new Date(dateObj);
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())).toISOString();
};

export const fromUTCDateString = (isoString) => {
    if (!isoString) return null;
    const d = new Date(isoString);
    return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
};